<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">交易单管理</el-breadcrumb-item>
                <el-breadcrumb-item>开票信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="$router.back(-1)">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>交易单号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.no}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row" v-if="voucher.contractNo != null">
                <div class="form-label">
                    <label>合同编号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span> {{voucher.contractNo}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>交易状态</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span v-if="voucher.totalZxAmount == 0 && voucher.paidAmount > 0">已预付款</span>
                        <span v-if="parseFloat(voucher.paidAmount) < parseFloat(voucher.totalZxAmount) && voucher.totalZxAmount != 0 && voucher.paidAmount > 0 && !voucher.payFinished">部分付款</span>
                        <span v-if="parseFloat(voucher.paidAmount) >= parseFloat(voucher.totalZxAmount) && voucher.totalZxAmount != 0 || voucher.payFinished">已付款</span>
                        <span v-if="voucher.paidAmount == 0">未付款</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>客户名称</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.buyerName}}</span>
                    </div>
                </div>
            </div>
            <hr class="dashed" />
            <div class="form-row" v-if="voucher.contractNo != null">
                <div class="form-label">
                    <label>预计交易总金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.estmtAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>累计订单金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.totalZxAmount)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>已支付金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.paidAmount)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>已退款金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.refundedAmount)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>已开发票金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.madeOutAmount)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>申请中发票金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{(parseFloat(voucher.applingMakeOutAmount || 0)).toFixed(2)}}</span>
                    </div>
                </div>
            </div>
            <hr class="dashed" />
            <div class="form-row">
                <div class="form-label">
                    <label>发票类型</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.invoiceTypeText}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>发票主体类型</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.invoiceSubjectTypeText}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>发票内容</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.invoiceContentTag}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>发票抬头</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.invoiceTitle}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>纳税人识别号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{voucher.taxPayerNo}}</span>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>是否开票完毕</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="voucher.makeOutFinished">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div class="table-layout">
                <el-table ref="multipleTable" :data="invoiceVoucherList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column prop="tradeNo" align="center" label="交易单号" width="183px;"></el-table-column>
                    <el-table-column prop="sellerName" label="客户名称" width="150px;"></el-table-column>
                    <el-table-column prop="invoiceTypeText" label="发票类型" width="120px;"></el-table-column>
                    <el-table-column prop="invoiceTitle" label="发票抬头" width="150px;"></el-table-column>
                    <el-table-column prop="taxPayerNo" label="纳税人识别号" width="130px;"></el-table-column>
                    <el-table-column prop="actualNo" label="发票号" width="120px;"></el-table-column>
                    <el-table-column prop="electFlag" align="center" label="是否电子发票" width="120px;">
                        <template slot-scope="rows">
                            <span v-if="rows.row.electFlag">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="开票金额(元)" width="120px;" align="right"></el-table-column>
                    <el-table-column prop="madeOut" align="center" label="是否已开票" width="120px;">
                        <template slot-scope="rows">
                            <span v-if="rows.row.madeOut">是</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="applyTime" align="center" label="申请日期" width="180px"></el-table-column>
                    <el-table-column prop="auditStateText" label="审核状态"></el-table-column>
                    <el-table-column prop="invalid" align="center" label="是否作废" width="100px;">
                        <template slot-scope="rows">
                            <span class="font-red" v-if="rows.row.invalid">是</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import tradeApi from '../../api/trade'
    import finacApi from '../../api/finac'

    export default{
        name: 'swb-trade-voucher-invoice-info',
        path: '/trade/invoice/info',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '交易单开票信息',
        notAsResc: true,
        authen: false,
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                voucher: {},
                invoiceVoucherList: [],
                tradeId: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.tradeId = this.$route.query.tradeId || null;
            //
            this.getInvoiceVoucherList();
        },
        methods: {
            // 交易单详情
            getVoucherDetail: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                tradeApi.getTradeVoucher(postData, function (result) {
                    if(result.type == 'info') {
                        self.voucher = result.data;
                        let invoiceTypeInfo = getEnumInfoWith('invoiceType', 'value', self.voucher.invoiceType);
                        if(!Utils.isNoB(invoiceTypeInfo)) {
                            self.voucher.invoiceTypeText = invoiceTypeInfo.text;
                        }
                        let invoiceSubjectTypeInfo = getEnumInfoWith('invoiceSubjectType', 'value', self.voucher.invoiceSubjectType);
                        if(!Utils.isNoB(invoiceSubjectTypeInfo)) {
                            self.voucher.invoiceSubjectTypeText = invoiceSubjectTypeInfo.text;
                        }
                        //
                        let applingMakeOutAmount = self.voucher.appliedMakeOutAmount - self.voucher.madeOutAmount;
                        if(!Utils.isNoB(applingMakeOutAmount)) {
                            self.voucher.applingMakeOutAmount = applingMakeOutAmount;
                        } else {
                            self.voucher.applingMakeOutAmount = 0;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 分页信息
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getInvoiceVoucherList();
            },
            // 获取发票单据列表
            getInvoiceVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if(!Utils.isNoB(self.tradeId) && self.tradeId != -1) {
                    filterItems.tradeId = self.tradeId;
                }
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getInvoiceVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let invoiceVoucherList = result.data.rows;
                        if(!Utils.isNoB(invoiceVoucherList) && invoiceVoucherList.length > 0) {
                            for(let i = 0; i < invoiceVoucherList.length; i++) {
                                let invoiceVoucher = invoiceVoucherList[i];
                                //
                                invoiceVoucher.amount = invoiceVoucher.amount.toFixed(2);
                                //
                                let invoiceTypeInfo = getEnumInfoWith('invoiceType', 'value', invoiceVoucher.invoiceType);
                                if(!Utils.isNoB(invoiceTypeInfo)) {
                                    invoiceVoucher.invoiceTypeText = invoiceTypeInfo.text;
                                }
                                //
                                let auditStateInfo = getEnumInfoWith('auditState', 'value', invoiceVoucher.auditState);
                                if(!Utils.isNoB(auditStateInfo)) {
                                    invoiceVoucher.auditStateText = auditStateInfo.text;
                                }
                            }
                        }
                        self.invoiceVoucherList = invoiceVoucherList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    //
                    self.getVoucherDetail(self.tradeId);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherInvoiceInfo.vue